import React, { useState } from 'react';
import MaskedInput from "react-text-mask";
import strings from '../../strings/strings.json'

interface Props {
  placeholder: string
  ipValue: (ip: string) => void
}
const ipRegex = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/
export default function IpInput(props: Props) {

  const [isvalid, setIsValid] = useState(true)
  const [keyDownClicked, setKeyDownClicked] = useState(false)

  const prop = {
    guide: true,
    mask: (value: any) => {
      let result = [];
      const chunks = value.split(".");

      for (let i = 0; i < 4; ++i) {
        const chunk = (chunks[i] || "").replace(/_/gi, "");

        if (chunks.length === 4 && chunks[i].indexOf("_") !== -1 && keyDownClicked) {
          if (chunk.length == 1) {
            result.push(/\d/, ".");
            continue;
          } else {
            result.push(/\d/, /\d/, ".");
            continue;
          }
        }

        if (chunk === "") {
          result.push(/\d/, /\d/, /\d/, ".");
          continue;
        } else if (+chunk === 0) {
          result.push(/\d/, ".");
          continue;
        } else if (
          chunks.length < 4 ||
          (chunk.length < 3 && chunks[i].indexOf("_") !== -1)
        ) {
          if (
            (chunk.length < 2 && +`${chunk}00` > 255) ||
            (chunk.length < 3 && +`${chunk}0` > 255)
          ) {
            result.push(/\d/, /\d/, ".");
            continue;
          } else {
            result.push(/\d/, /\d/, /\d/, ".");
            continue;
          }
        } else {
          result.push(...new Array(chunk.length).fill(/\d/), ".");
          continue;
        }
      }
      setKeyDownClicked(false)
      result = result.slice(0, -1);
      return result;
    },
    pipe: (value: any) => {
      if (value === "." || value.endsWith("..")) return false;

      const parts = value.split(".");

      if (
        parts.length > 4 ||
        parts.some((part: any) => part === "00" || part < 0 || part > 255)
      ) {
        return false;
      }
      return value;
    }
  };

  const onChageHandler = (e: any) => {
    const value = e.target.value.replace(/_/gi, "")
    if (!value) {
      setIsValid(true)
      props.ipValue(value)
    } else if (!ipRegex.test(value)) {
      setIsValid(false)
    } else {
      setIsValid(true)
      props.ipValue(value)
    }
  }

  const onKeyDownHandler = (e: any) => {
    if (e.key === 'Enter') {
      setKeyDownClicked(true)
    }
  }

  return (
    <div className='flex flex-col text-right'>
      <div dir='ltr'>
        <MaskedInput
          onKeyDown={onKeyDownHandler}
          className='VazirEng border border-gray-200 rounded p-1 text-left mb-1'
          {...prop} placeholder={props.placeholder}
          onChange={onChageHandler}
        />
      </div>
      {!isvalid && <span className='text-red-500 text-xs font-bold'>{strings.internet_validIp}</span>}
    </div>
  )
}
